import type { StageTone } from "@estelle/domain";

/**
 * The classes of each stage tone: the stage badge's fill and ink, and the
 * order journey's bar (#682), so the two always agree. Each pair has a
 * dark-theme counterpart in the tint tokens.
 */
export const STAGE_TONE_CLASS: Record<StageTone, string> = {
  grey: "border-border bg-muted text-foreground",
  blue: "border-transparent bg-tint-blue text-tint-blue-foreground",
  amber: "border-transparent bg-tint-yellow text-tint-yellow-foreground",
  green: "border-transparent bg-tint-green text-tint-green-foreground",
  red: "border-destructive/40 bg-destructive/10 text-destructive",
  dark: "border-transparent bg-foreground/85 text-background",
};
